import { findPanelResizeInput } from './findPanelResizeInput';

/** Reads the current panel width (px), or `null` if the panel can't be found. */
export const getCurrentPanelWidth = (fromElement: HTMLElement | null): number | null => {
	const input = findPanelResizeInput(fromElement);
	if (!input) {
		return null;
	}
	// Focus so the splitter refreshes the input's value/bounds before we read.
	input.focus();
	const value = Number(input.value);
	return Number.isFinite(value) ? value : null;
};
